module.exports = __webpack_public_path__ + "media/src/images/mails/ea4e44-4dde4610d82c02dd3dcacfd5f19675f2.png";